import React, { useCallback, useEffect, useRef, useState, Fragment } from 'react';
import { css, keyframes } from '@kufox/mui/emotion';
import { useLang } from '../../hookTool';
import closeIcon from '../../../static/newHeader/maintenance_close.svg';

export const HEIGHT = 40;

const wordsLoop = keyframes`
  0% {
    transform: translateX(0px);
  }
  100% {
    transform: translateX(calc(-100% - 300px));
  }
`;

const useStyles = () => {
  return {
    wrapper: css`
      display: flex;
      flex-direction: row;
      align-items: center;
      height: ${HEIGHT}px;
      text-align: center;
      background: linear-gradient(0deg, rgba(255, 181, 71, 0.08), rgba(255, 181, 71, 0.08)), #ffffff;
      color: #00142a;
      line-height: ${HEIGHT}px;
      padding-right: 40px;
    `,
    content: css`
      overflow: hidden;
      font-weight: normal;
      font-size: 14px;
      text-align: center;
      color: #00142a;
      margin-right: 8px;
      white-space: nowrap;
    `,
    link: css`
      line-height: 24px;
      display: inline-block;
      padding: 2px 8px;
      border: 0.5px solid #ffb547;
      text-align: center;
      border-radius: 4px;
      font-weight: 500;
      font-size: 12px;
      line-height: 20px;
      word-break: keep-all;
      white-space: nowrap;
      color: #ffb547;
      & a,
      a:hover,
      a:visited,
      a:active {
        color: #ffb547;
        textdecoration: none;
      }
    `,
    closeIcon: css`
      width: 16px;
      height: 16px;
      cursor: pointer;
      margin-left: 10px;
    `,
    animate: css`
      & > span {
        display: inline-block;
        animation: ${wordsLoop} 30s linear infinite;
      }
      &:hover {
        & > span {
          animation-play-state: paused;
        }
      }
    `,
    mirror: css`
      margin-left: 300px;
    `,
  };
};

export default (props) => {
  const { theme = 'dark', pathname, maintenance, maintainancePath, closeShow } = props;
  const { t } = useLang();
  const classes = useStyles();
  const titleRef = useRef(null);
  const titleParentRef = useRef(null);
  const [scrollCls, setScrollCls] = useState('');
  const clickClose = useCallback(() => {
    if (typeof closeShow === 'function') {
      closeShow();
    }
  }, [closeShow]);
  const {
    title = '', // 公告内容
    link = '', // 公告跳转链接
    redirectContent = '', // 跳转文本
  } = maintenance || {};

  useEffect(() => {
    // 如果通告内容区域超长，则进行滚动播放，添加animate class
    // 加上一定的延时，防止拿不到正确的dom size
    setTimeout(() => {
      const titleEl = titleRef.current;
      const parentEl = titleParentRef.current;
      if (titleEl && parentEl) {
        if (titleEl.clientWidth > parentEl.clientWidth + 12) {
          setScrollCls(classes.animate);
        } else {
          setScrollCls('');
        }
      }
    }, 500);
  }, [titleRef, titleParentRef, setScrollCls, classes, scrollCls]);
  return (
    <div css={classes.wrapper}>
      <div
        style={{
          display: 'flex',
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'hidden',
        }}
      >
        <span css={classes.content} ref={titleParentRef}>
          <span
            ref={titleRef}
            css={scrollCls}
            style={{
              display: 'inline-block',
            }}
          >
            {scrollCls ? (
              <Fragment>
                <span>{title}</span>
                <span css={classes.mirror}>{title}</span>
              </Fragment>
            ) : (
              <span>{title}</span>
            )}
          </span>
        </span>
        {link && (
          <span css={classes.link}>
            <a href={link} target="_blank">
              {redirectContent || t('view.more')}
            </a>
          </span>
        )}
      </div>
      <img css={classes.closeIcon} src={closeIcon} onClick={clickClose} />
    </div>
  );
};
